import { DataTableFilterableColumn } from '../../components/DataTable/types';
import { AdminPermission, Role } from '../../types';

// Wiersz tabeli /users — dane z backendu (v3-getUsers). `associated_organization`
// i `organizations` to NAZWY hoteli (join robi backend), surowe id siedzą
// w `organizationId` / `organizationIds`.
export interface UserWithHotel {
  id: string;
  email: string;
  displayName?: string;
  name?: string;
  surname?: string;
  firstLogin?: boolean;
  isStore?: boolean;
  isAdmin?: boolean;
  /** Flaga personelu zapisana w dokumencie `users/{uid}` (skrypt setStaff). */
  isStaff?: boolean;
  /** Id hoteli, których user jest właścicielem (`users/{uid}.owner`). */
  owner?: string[];
  /** NAZWY hoteli z `owner` — join robi backend, jak przy `organizations`. */
  ownerHotels?: string[];
  /** Administrator HotelSpot (`users/{uid}.isHotelspotAdmin` + claim). */
  isHotelspotAdmin?: boolean;
  /** Zawężenie uprawnień admina (`adminPermission`); null = pełny dostęp. */
  adminPermission?: AdminPermission | null;
  /** Ostatnie logowanie z Firebase Auth (ms) — `null`, gdy user nigdy się nie logował. */
  lastLoginAt?: number | null;
  createdAt?: number | null;
  organizationId?: string;
  organizationIds?: string[];
  associated_organization?: string;
  organizations?: string[];
  photoURL?: string;
  role?: Role[];
  phoneNumber?: string;
  permissions?: string[];
  staffService?: boolean;
  staffServicePermissions?: string[];
  language?: string | null;
}

export type UsersPaginatedDataModel = {
  data: UserWithHotel[];
  totalPages: number;
  total: number;
};

export type UsersPaginatedFilters = {
  hotelId?: string;
  /** Case-insensitive szukanie po e-mailu, imieniu, nazwisku, displayName
   *  i telefonie — filtruje backend (v3-getUsers). */
  searchTerm?: string;
};

export const USERS_FILTER_CONFIG: DataTableFilterableColumn[] = [];

export const USERS_QUERY_KEY = 'users';

// ─── Kontrakt backendu (codebase `admin`, katalog `user`) ────────────────────

export type GetUsersApiResponse = {
  success: boolean;
  message: string;
  data: {
    users: UserWithHotel[];
    totalPages: number;
    total: number;
  };
};

export type GetUserApiResponse<T> = {
  success: boolean;
  message: string;
  data: { user: T };
};

export type DeleteUsersResult = {
  deletedCount: number;
  totalRequested: number;
  failedIds: string[];
};

export type DeleteUsersApiResponse = {
  success: boolean;
  message: string;
  data: DeleteUsersResult;
};

// ── Backfill claimu `isStaff` (v3-backfillStaffClaims) ─────────────────────────

export type StaffClaimBackfillEntry = {
  uid: string;
  email: string | null;
  /** Czego brakowało: claim w Auth, pole w dokumencie, albo oba. */
  missing: Array<'claim' | 'field'>;
};

export type StaffClaimBackfillSummary = {
  dryRun: boolean;
  scanned: number;
  /** Konta, którym nadano (w podglądzie: nadano by) claim/pole. */
  updated: StaffClaimBackfillEntry[];
  alreadyComplete: number;
  /** Dokumenty `users/{uid}` bez konta Firebase Auth — pominięte. */
  missingAuth: string[];
  /** Dokumenty, które nie wyglądają na personel — pominięte, do przejrzenia. */
  skippedNotStaff: Array<{ uid: string; email: string | null }>;
  errors: Array<{ uid: string; message: string }>;
};

export type StaffClaimBackfillApiResponse = {
  success: boolean;
  message: string;
  data: StaffClaimBackfillSummary;
};

/** Jeden zapisany przebieg backfillu (dokument `staffClaimBackfillRuns/{id}`). */
export type StaffClaimBackfillRun = {
  id: string;
  createdAt: number | null;
  runBy: { uid: string; email: string | null };
  dryRun: boolean;
  scanned: number;
  updatedCount: number;
  alreadyComplete: number;
  missingAuthCount: number;
  skippedNotStaffCount: number;
  errorCount: number;
  updated: StaffClaimBackfillEntry[];
  missingAuth: string[];
  skippedNotStaff: Array<{ uid: string; email: string | null }>;
  errors: Array<{ uid: string; message: string }>;
};

export type StaffClaimBackfillRunsApiResponse = {
  success: boolean;
  message: string;
  data: StaffClaimBackfillRun[];
};

export const STAFF_CLAIM_BACKFILL_RUNS_QUERY_KEY = 'staffClaimBackfillRuns';
